export default function Page({ pageNum, isSelected }) {
	return (
		<span
			className={[
				"flex h-[30px] w-[30px] items-center justify-center rounded-full font-Vazir-600 text-[15px] leading-none",
				"transition-colors",
				isSelected
					? "bg-cta text-white shadow-[0_2px_8px_rgba(255,106,75,0.35)]"
					: "bg-[#E8EEF5] text-midGray hover:bg-[#D4E3F0] hover:text-darkBlue",
			].join(" ")}
		>
			{pageNum}
		</span>
	);
}
